import { computed, ComputedRef } from 'vue';
// import getID from '@/components/bootstrap-library/utils/getID';
import {getId} from '../utils'

function useId(id?: string, suffix?: string): ComputedRef<string> {
    const computedId = computed(() => id || getId(suffix));

    return computedId;
}

export default useId;
